<template>
  <div class="prop-item" @click="chooseProp">
    <img
      class="prop-item-img"
      :src="getGamePropIco(detail.ICON)"
      @error="handleImgError"
      alt=""
    />
    <span class="prop-item-num">{{ detail.AMOUNT || detail.COUNT }}</span>
  </div>
</template>

<script>
import propImg from '@mixins/officialStore/propImg'
export default {
  name: 'PropItem',
  mixins: [propImg],
  props: ['detail'],
  methods: {
    chooseProp() {
      this.$emit('chooseProp', this.detail)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.prop-item {
  position: relative;
  flex-shrink: 0;
  margin-right: 8px;
  background-size: cover;
  @psetbg ('prop-item-bg.png');
  &-num {
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 17px;
    color: var(--product-item-prop-num);
  }
  &-img {
    position: absolute;
    left: 50%;
    bottom: 6px;
    width: 73px;
    transform: translateX(-50%);
  }
  &-prop {
    position: absolute;
    left: 0;
    bottom: -10px;
  }
}

</style>